import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aefb388"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("自定义按钮")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({
      'background-color': _ctx.bgColor,
      'color': _ctx.color,
      'font-size:': _ctx.fontSize,
      'width': _ctx.width,
      'height': _ctx.height,
      'line-height': _ctx.height,
      'padding': _ctx.padding, 
      'border-radius': _ctx.borderRadius,
      }),
    class: _normalizeClass([
        'btn-wrapper',
        _ctx.animationName,
        {'load-more': _ctx.btnType === 'load-more'},
        {'tab-btn1': _ctx.btnType === 'tab-btn1'},
        {'tag3': _ctx.btnType === 'tag3'},
        {'left-top-tag2': _ctx.btnType === 'left-top-tag2'},
        {'right-top-tag': _ctx.btnType === 'right-top-tag'},
        {'left-top-tag': _ctx.btnType === 'left-top-tag'},
        {'small':_ctx.size === 'small'},
        {'middle':_ctx.size === 'middle'},
        {'big':_ctx.size === 'big'},
      ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_2
      ], true)
    ])
  ], 6))
}